//local imports
import { Messenger } from "@app/shared";
import { ToastLevel, ToastMessage } from "@app/components";
import {
  CatalogStateService,
  RefreshFilterMessage,
  ProjectModel,
} from "@app/catalog";

import {
  ProjectCreatedNotification,
  ProjectUpdatedNotification,
  ProjectAddedMessage,
  ProjectUpdatedMessage,
} from "@app/catalog-common";

export class ProjectStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      ProjectCreatedNotification,
      (message: ProjectCreatedNotification) => {
        let project = new ProjectModel();

        project.id = message.projectId;

        project.name.set(message.projectName);

        this.updateProject(project, message);

        catalogStateService.CatalogManagementState.projects.set([
          project,
          ...catalogStateService.CatalogManagementState.projects(),
        ]);

        messenger.send(
          ToastMessage.create(
            new ProjectAddedMessage(project),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    messenger.subscribe(
      catalogStateService,
      ProjectUpdatedNotification,
      (message: ProjectUpdatedNotification) => {
        let project =
          catalogStateService.CatalogManagementState.projects().find(
            (u) => u.id === message.projectId,
          );

        if (!project) {
          project = new ProjectModel();
          project.id = message.projectId;

          project.name.set(message.projectName);
        }

        this.updateProject(project, message);

        messenger.send(new RefreshFilterMessage());
        messenger.send(
          ToastMessage.create(
            new ProjectUpdatedMessage(project),
            ToastLevel.Information,
          ),
        );
      },
    );
  }

  private updateProject(
    project: ProjectModel,
    message: ProjectCreatedNotification | ProjectUpdatedNotification,
  ) {
    //TODO:DIW:Move into it's own class..
    //TODO:DIW:Set properties by reading changed properties collection and mapping..

    for (let change of message.changes) {
      if (change.propertyName.toLowerCase() === "name") {
        project.name.set(change.newValue);
      }
    }
  }
}
